var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.showInstaller, "can-cancel": false, scroll: "keep" },
      on: {
        "update:active": function ($event) {
          _vm.showInstaller = $event
        },
        close: _vm.cancelar,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("h1", { staticClass: "title is-4" }, [
            _c("i", { staticClass: "fas fa-cube" }),
            _vm._v(" Instalación: Repositorio"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("Configuración de parametros"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Donde se guardarán las carpetas de los usuarios"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": false },
                    model: {
                      value: _vm.showExplorer,
                      callback: function ($$v) {
                        _vm.showExplorer = $$v
                      },
                      expression: "showExplorer",
                    },
                  },
                  [
                    _vm._v(
                      "\n              En la carpeta raiz de la organización ("
                    ),
                    _c("span", { staticClass: "is-mono" }, [
                      _vm._v("/" + _vm._s(_vm.organizacion.slug)),
                    ]),
                    _vm._v(")\n          "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": true },
                    model: {
                      value: _vm.showExplorer,
                      callback: function ($$v) {
                        _vm.showExplorer = $$v
                      },
                      expression: "showExplorer",
                    },
                  },
                  [
                    _vm._v(
                      "\n              En una carpeta especifica de la organización\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showExplorer
              ? _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "button is-static is-fullwidth has-text-left",
                        },
                        [_vm._v(_vm._s(_vm.getRuta))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "help" }, [
                      _vm._v(
                        "Elija la carpeta donde se guardarán las carpetas de los usuarios"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("explorer", {
                      ref: "listado",
                      attrs: {
                        idFolder:
                          _vm.settings.origen_id || _vm.organizacion.slug,
                        rutas: _vm.rutas,
                        selected: _vm.selected,
                      },
                      on: {
                        "update:rutas": function ($event) {
                          _vm.rutas = $event
                        },
                        "update:selected": function ($event) {
                          _vm.selected = $event
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-8" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Patrón carpeta del usuario"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settings.patron_carpeta,
                          expression: "settings.patron_carpeta",
                        },
                      ],
                      staticClass: "input",
                      class: { "is-danger": _vm.errors.has("patronCarga") },
                      attrs: { type: "text", name: "patronCarga" },
                      domProps: { value: _vm.settings.patron_carpeta },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings,
                            "patron_carpeta",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column content is-small" }, [
              _c("table", { staticClass: "table is-narrow" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { colspan: "2" } }, [
                      _vm._v("Patrones disponibles"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("#ua")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Nombre del usuario")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#uc")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("CUIL del usuario")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#ui")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Id del usuario")]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("div", { staticClass: "buttons is-pulled-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-dark is-outlined",
                  on: { click: _vm.cancelar },
                },
                [_vm._v("\n            Cancelar\n          ")]
              ),
              _vm._v(" "),
              _vm.params
                ? _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: _vm.errors.count() > 0 },
                      on: { click: _vm.reinstalar },
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: _vm.errors.count() > 0 },
                      on: { click: _vm.instalar },
                    },
                    [_vm._v("\n            Instalar módulo\n          ")]
                  ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }